<div class="library-upload-view">
  <div class="flex-container">
    <div class="flex-item">
      <div class="card">
        <!-- <div class="card-header">
        <p class="card-header-title">Create new lesson</p>
      </div> -->
        <div class="card-content pos-relative" style="display: none">
          <div class="dropdown is-hoverable">
            <div class="dropdown-trigger" (click)="llmFileInput.click()" data-tooltip="Upload File..."></div>
            <div class="file">
              <label class="file-label">
                <input type="file" name="msg-file" id="uploadfile" style="display: none"
                  (change)="chooseUploadFilellm($event)" #llmFileInput
                  accept=".png, .jpeg, .jpg, .mp3, .mp4, .wav, .pdf, .ppt, .pptx, .xml, .xls, .xlsx, .doc, .docx, .txt" />
                <span class="file-cta">
                  <span class="file-icon">
                    <i class="fa fa-upload"></i>
                  </span>
                  <span class="file-label"> Upload a file… </span>
                </span>
              </label>
            </div>
          </div>
        </div>
        <div class="tabs stepper is-info is-outlined is-fullwidth is-small questionariesTab">
          <ul>
            <!-- Step 1 -->
            <li class="tab" [ngClass]="{
                'is-active': stepperIndex === 0,
                complete: stepperIndex > 0
              }" (click)="openStepperTab(0, 'lesson')">
              <span class="step-number">1</span>
              <span class="edit">
                <i class="pi pi-pen-to-square"></i>
              </span>
              <span class="check-mark">
                <i class="pi pi-check"></i>
              </span>
              <a>New Document</a>
              <span class="line-horizontal"></span>
            </li>

            <!-- Step 2 -->
            <li class="tab" [ngClass]="{
                'is-active': stepperIndex === 1,
                complete: stepperIndex > 1
              }" (click)="openStepperTab(1, 'assessment')">
              <span class="step-number">2</span>
              <span class="edit">
                <i class="pi pi-pen-to-square"></i>
              </span>
              <span class="check-mark">
                <i class="pi pi-check"></i>
              </span>
              <a>Assessment</a>
              <span class="line-horizontal"></span>
            </li>

            <!-- Step 3 -->
            <li class="tab" [ngClass]="{
                'is-active': stepperIndex === 2,
                complete: stepperIndex > 2
              }" (click)="openStepperTab(2, 'survey')">
              <span class="step-number">3</span>
              <span class="edit">
                <i class="pi pi-pen-to-square"></i>
              </span>
              <span class="check-mark">
                <i class="pi pi-check"></i>
              </span>
              <a>Survey</a>
              <span class="line-horizontal"></span>
            </li>

            <!-- Step 4 -->
            <li class="tab" [ngClass]="{
                'is-active': stepperIndex === 3,
                complete: stepperIndex > 3
              }" (click)="openStepperTab(3, 'poll')">
              <span class="step-number">4</span>
              <span class="edit">
                <i class="pi pi-pen-to-square"></i>
              </span>
              <span class="check-mark">
                <i class="pi pi-check"></i>
              </span>
              <a>Poll</a>
              <span class="line-horizontal"></span>
            </li>

            <!-- Step 5 -->
            <li class="tab" [ngClass]="{
                'is-active': stepperIndex === 4,
                complete: stepperIndex > 4
              }" (click)="openStepperTab(4, 'notes')">
              <span class="step-number">5</span>
              <span class="edit">
                <i class="pi pi-pen-to-square"></i>
              </span>
              <span class="check-mark">
                <i class="pi pi-check"></i>
              </span>
              <a>Notes</a>
            </li>
          </ul>
        </div>
        <div class="card-body py-0" appInfiniteScroll infinite-scroll [scrollWindow]="true"
          [infiniteScrollDistance]="modalScrollDistance" [infiniteScrollThrottle]="modalScrollThrottle">
          <form [formGroup]="uploadFileForm" novalidate>
            <div class="pos-relative" infinite-scroll>
              <div class="row is-clearfix">
                <div class="column upload-file-form is-5 scroll-bar" style="display: none">
                  <div class="field post-attach-file">
                    <label for="" class="">Upload File
                      <i class="fa fa-info-circle mar-5-0 label has-tooltip-bottom"
                        data-tooltip="Attach only PNG, JPEG, JPG, MP3, MP4, WAV, PDF, PPT, PPTX, XML, XLS, XLSX, DOC, DOCX, TXT file"
                        aria-hidden="true"></i>
                      <span class="required">*</span>
                    </label>
                    <div class="control profile-img" [ngClass]="{ 'small-img': upLoadedFileList.length !== 0 }">
                      @if (upLoadedFileList.length === 0) {
                      <div>
                        <!-- <img
                          [src]="'../../../assets/images/empty-state-attach.png'"
                          /> -->
                      </div>
                      } @if (upLoadedFileList.length !== 0) {
                      <div class="is-small">
                        @for (f of uploadFileIcons; track f) {
                        <div>
                          @if (f.name === upLoadedFileList[0].mimeType) {
                          <span>
                            <img [src]="f.icons" alt="" width="35px" height="35px" />
                            {{ upLoadedFileList[0].name }}
                            <button class="delete" aria-label="Delete"
                              (click)="removeUploadFile(upLoadedFileList)"></button>
                          </span>
                          }
                        </div>
                        }
                      </div>
                      } @if (upLoadedFileList.length === 0) {
                      <span class="img-options">
                        <div class="dropdown is-hoverable">
                          <div class="dropdown-trigger" (click)="elibraryFileInput.click()"
                            data-tooltip="Upload File..."></div>
                          <div class="file">
                            <label class="file-label">
                              <input type="file" name="msg-file" id="uploadfile" style="display: none"
                                (change)="chooseUploadFile($event)" #elibraryFileInput
                                accept=".png, .jpeg, .jpg, .mp3, .mp4, .wav, .pdf, .ppt, .pptx, .xml, .xls, .xlsx, .doc, .docx, .txt" />
                              <span class="file-cta">
                                <span class="file-icon">
                                  <i class="fa fa-upload"></i>
                                </span>
                                <span class="file-label"> Upload a file… </span>
                              </span>
                            </label>
                          </div>
                        </div>
                      </span>
                      }
                    </div>
                  </div>
                  <div class="field">
                    <label class="label">Duration</label>
                    <!-- <div class="control">
                      <input
                        class="input"
                        type="text"
                        name="duration"
                        placeholder="Video/Audio File Duration"
                        formControlName="duration"
                        #durationInput
                        aria-disabled="true"
                        [readonly]="true"
                        />
                      </div> -->
                  </div>

                  <div class="field">
                    <label class="label">Title
                      <span class="required">*</span>
                    </label>
                    <div class="control">
                      <input class="input" type="text" name="title" placeholder="Title" formControlName="title" />
                      <form-validation [control]="uploadFileForm.controls.title"></form-validation>
                    </div>
                  </div>
                  <div class="field responsiveRadioBtn">
                    <input id="switchDownload" type="checkbox" name="download_link" class="switch is-small is-success"
                      formControlName="download_link" [(ngModel)]="isDownload" />
                    <label for="switchDownload">Allow download?</label>
                  </div>
                  <div class="field responsiveRadioBtn">
                    <input id="switchDownload" type="checkbox" name="download_link" class="switch is-small is-success"
                      formControlName="download_link" [(ngModel)]="isDownload" />
                    <label for="switchDownload">Allow LLM?</label>
                  </div>
                  <!-- <div class="field responsiveRadioBtn">
                        <input
                          id="switchPublish"
                          type="checkbox"
                          name="publish"
                          class="switch is-small is-success"
                          formControlName="publish"
                          [(ngModel)]="isPublish"
                          />
                          <label for="switchPublish">Publish this lesson?</label>
                        </div> -->

                  <div class="field">
                    <label class="label">Description</label>
                    <div class="control">
                      <!-- <angular-editor
                            class="scroll-bar"
                            formControlName="description"
                            [config]="editorConfig"
                            cols="10"
                            rows="2"
                          ></angular-editor> -->
                      <p-editor formControlName="description" [style]="{ height: '320px' }" />
                    </div>
                  </div>
                  <div class="columns">
                    <div class="column">
                      <div class="field">
                        <label class="label">Price $</label>
                        <div class="control">
                          <input type="text" class="input" name="price" placeholder="Price $" formControlName="price"
                            (keypress)="numberOnlyValidator($event)" (keydown)="IsDecimalValue($event)" />
                          @if (priceValidate) {
                          <p class="is-small has-text-danger">
                            {{ priceErrMsg }}
                          </p>
                          }
                        </div>
                      </div>
                    </div>
                    <div class="column">
                      <div class="field">
                        <label class="label">Discount %</label>
                        <div class="control">
                          <input type="text" class="input" name="discount" placeholder="Discount"
                            formControlName="discount" (keypress)="isNumberKey($event)" maxlength="3"
                            (keyup)="discountPercentage($event)" />
                          @if (discountValidate) {
                          <p class="is-small has-text-danger">
                            {{ priceErrMsg }}
                          </p>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="field">
                    <label class="label">Watermark Title</label>
                    <div class="control">
                      <input type="text" class="input" name="watermark_title" placeholder="Watermark Title"
                        formControlName="watermark_title" />
                    </div>
                  </div>
                </div>
                <!-- <div class="col-md-6"> -->
                <!-- <div class="field"> -->

                <!-- <div class="container container-file scroll-bar"> -->
                <!-- <div id="trainllm" class="content-tab row">
                          <div class="card-content  pos-relative"  >
                            <div class="dropdown is-hoverable">
                              <div
                                class="dropdown-trigger"
                                (click)="llmFileInput.click()"
                                data-tooltip="Upload File..."
                              ></div>
                              <div class="file">
                                <label class="file-label">
                                  <input
                                    type="file"
                                    name="msg-file"
                                    id="uploadfile"
                                    style="display: none"
                                    (change)="chooseUploadFilellm($event)"
                                    #llmFileInput
                                    accept=".png, .jpeg, .jpg, .mp3, .mp4, .wav, .pdf, .ppt, .pptx, .xml, .xls, .xlsx, .doc, .docx, .txt"
                                    />
                                    <span class="file-cta">
                                      <span class="file-icon">
                                        <i class="fa fa-upload"></i>
                                      </span>
                                      <span class="file-label"> Upload a file… </span>
                                    </span>
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div> -->
                <div id="lesson" class="content-tab row">
                  <!-- <div class="scroll-bar"> -->
                  <div class="col-md-6">
                    <div class="row">
                      <div class="file-upload-container">
                        <label class="upload-label">
                          Upload Document <span class="required">*</span>
                        </label>

                        <div class="upload-card" [ngClass]="{
                            'file-added': upLoadedFileList.length !== 0
                          }" (click)="
                            upLoadedFileList.length === 0
                              ? elibraryFileInput.click()
                              : null
                          ">
                          <!-- Upload Placeholder -->
                          @if (upLoadedFileList.length === 0) {
                          <div class="upload-placeholder">
                            <i class="fa-solid fa-cloud-arrow-up upload-icon"></i>
                            <p class="upload-title">
                              Click here to upload the document.
                            </p>
                            <p class="upload-subtitle">
                              MP3, MP4, WAV, PDF, PPT, XLS, DOC, TXT
                            </p>
                            <p class="upload-size">Maximum size: 1GB</p>
                          </div>
                          }

                          <!-- Uploaded File Preview -->
                          @if (upLoadedFileList.length !== 0) {
                          <div class="uploaded-file">
                            @if (getFileIcon(); as fileIcon) {
                            <div class="file-info">
                              <img [src]="fileIcon.icons" class="file-icon" />
                              <div class="file-details">
                                <p class="file-name">
                                  {{
                                  upLoadedFileList[0].name.length > 50
                                  ? (upLoadedFileList[0].name
                                  | slice : 0 : 50) + "..."
                                  : upLoadedFileList[0].name
                                  }}
                                </p>
                                <!-- <p class="file-type">
                                              {{ upLoadedFileList[0].mimeType }}
                                            </p> -->
                              </div>
                              <button class="remove-file" (click)="removeUploadFile(upLoadedFileList)">
                                <i class="fa-solid fa-xmark"></i>
                              </button>
                            </div>
                            }
                          </div>
                          }
                        </div>

                        <input type="file" #elibraryFileInput style="display: none" (change)="chooseUploadFile($event)"
                          accept=".mp3,.mp4,.wav,.pdf,.ppt,.pptx,.xml,.xls,.xlsx,.doc,.docx,.txt" />
                      </div>
                    </div>

                    @if (upLoadedFileList.length !== 0 &&
                    (upLoadedFileList[0].mimeType === 'mp3' ||
                    upLoadedFileList[0].mimeType === 'mp4' ||
                    upLoadedFileList[0].mimeType === 'wav')) {
                    <div class="field">
                      <label class="label">Duration</label>
                      <div class="control">
                        <input class="input" type="text" name="duration" placeholder="Video/Audio File Duration"
                          formControlName="duration" #durationInput aria-disabled="true" [readonly]="true" />
                      </div>
                    </div>
                    }

                    <div class="field">
                      <label class="label">Document Name
                        <span class="required">*</span>
                      </label>
                      <div class="control">
                        <input class="input" type="text" name="title" placeholder="Title" formControlName="title" />
                        <form-validation [control]="uploadFileForm.controls.title"></form-validation>
                      </div>
                    </div>
                    <div class="field">
                      <label class="label">
                        Policy State
                        <span class="required">*</span>
                      </label>

                      <div class="control">
                        <select class="input" name="policy_state" formControlName="policy_state">
                          <option value="" disabled>Select Policy State</option>

                          <option *ngFor="let state of stateNames | keyvalue" [value]="state.key">
                            {{ state.value }}
                          </option>
                        </select>

                        <form-validation [control]="uploadFileForm.controls.policy_state"></form-validation>
                      </div>
                    </div>
                    <div class="field responsiveRadioBtn">
                      <input id="switchDownload" type="checkbox" name="download_link" class="switch is-small is-success"
                        formControlName="download_link" [(ngModel)]="isDownload" />
                      <label for="switchDownload">Allow download?</label>
                    </div>
                    <!-- <div class="field responsiveRadioBtn">
                                  <input
                                    id="switchDownload"
                                    type="checkbox"
                                    name="download_link"
                                    class="switch is-small is-success"
                                    formControlName="download_link"
                                    [(ngModel)]="isDownload"
                                    />
                                    <label for="switchDownload">Allow LLM?</label>
                                  </div> -->
                    <div class="field" style="display: none">
                      <label class="label">Watermark Title</label>
                      <div class="control">
                        <input type="text" class="input" name="watermark_title" placeholder="Watermark Title"
                          formControlName="watermark_title" />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <!-- <div class="field responsiveRadioBtn">
                                    <input
                                      id="switchPublish"
                                      type="checkbox"
                                      name="publish"
                                      class="switch is-small is-success"
                                      formControlName="publish"
                                      [(ngModel)]="isPublish"
                                      />
                                      <label for="switchPublish">Publish this lesson?</label>
                                    </div> -->

                    <div class="field">
                      <label class="label">Description</label>
                      <div class="control">
                        <!-- <angular-editor
                                        class="scroll-bar"
                                        formControlName="description"
                                        [config]="editorConfig"
                                        cols="10"
                                        rows="2"
                                      ></angular-editor> -->
                        <p-editor formControlName="description" [style]="{ height: '220px' }" />
                      </div>
                    </div>
                    <div class="field" style="display: none">
                      <label class="label">Price $</label>
                      <div class="control">
                        <input type="text" class="input" name="price" placeholder="Price $" formControlName="price"
                          (keypress)="numberOnlyValidator($event)" (keydown)="IsDecimalValue($event)" />
                        @if (priceValidate) {
                        <p class="is-small has-text-danger">
                          {{ priceErrMsg }}
                        </p>
                        }
                      </div>
                    </div>

                    <div class="field" style="display: none">
                      <label class="label">Discount %</label>
                      <div class="control">
                        <input type="text" class="input" name="discount" placeholder="Discount"
                          formControlName="discount" (keypress)="isNumberKey($event)" maxlength="3"
                          (keyup)="discountPercentage($event)" />
                        @if (discountValidate) {
                        <p class="is-small has-text-danger">
                          {{ priceErrMsg }}
                        </p>
                        }
                      </div>
                    </div>
                  </div>
                  <!-- </div>   -->
                </div>
                <!--Assessment Section-->
                <div id="assessment" class="content-tab assessment-tab" style="display: none">
                  <div class="assessment-container">
                    <!-- Assessment Header -->
                    <div class="assessment-header">
                      <div>
                        <!-- <div class="assessment-eyebrow">
                                        <i class="fa-solid fa-clipboard-check"></i>
                                        Assessment
                                      </div> -->
                        <h3>Create Assessment</h3>
                        <p>
                          Configure assessment rules and add questions for your
                          learners.
                        </p>
                      </div>

                      @if (assQuestion().controls.length > 0) {
                      <div class="question-count">
                        <span>{{ assQuestion().controls.length }}</span>
                        <small>Question{{
                          assQuestion().controls.length > 1 ? "s" : ""
                          }}</small>
                      </div>
                      }
                    </div>

                    <!-- Assessment Settings -->
                    <div class="assessment-settings">
                      <div class="setting-card">
                        <div class="setting-icon">
                          <i class="fa-solid fa-percent"></i>
                        </div>

                        <div class="setting-content">
                          <label>Minimum Passing Score</label>
                          <span class="setting-description">
                            Minimum percentage required to pass
                          </span>

                          <div class="setting-input">
                            <input type="text" class="input" name="min_percentage" placeholder="Enter percentage"
                              formControlName="min_percentage" />
                            <span>%</span>
                          </div>
                        </div>
                      </div>

                      <div class="setting-card">
                        <div class="setting-icon">
                          <i class="fa-solid fa-rotate"></i>
                        </div>

                        <div class="setting-content">
                          <label>Allow Re-Test</label>
                          <span class="setting-description">
                            Allow learners to retake the assessment
                          </span>

                          <label class="modern-switch">
                            <input id="switchReTest" type="checkbox" name="is_allow_retest"
                              formControlName="is_allow_retest" [(ngModel)]="isAllowRetest" />
                            <span class="switch-slider"></span>
                          </label>
                        </div>
                      </div>

                      <div class="setting-card">
                        <div class="setting-icon">
                          <i class="fa-solid fa-shuffle"></i>
                        </div>

                        <div class="setting-content">
                          <label>Random Questions</label>
                          <span class="setting-description">
                            Number of questions shown randomly
                          </span>

                          <div class="setting-input">
                            <input type="text" class="input" name="random_question" placeholder="Enter number"
                              formControlName="random_question" (keydown)="keyDownHandler($event)"
                              (keypress)="numericOnlyHandler($event)" />
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Empty State / Create Question -->
                    @if (assQuestion().controls.length === 0) {
                    <div class="assessment-empty">
                      <div class="empty-icon">
                        <i class="fa-solid fa-clipboard-question"></i>
                      </div>
                      <h4>No questions added yet</h4>
                      <p>
                        Create your first assessment question manually or let AI
                        generate questions based on your selected document.
                      </p>
                      <div class="question-actions">
                        <!-- AI -->
                        @if ( trainLLM && isAssessmentAiEnabled &&
                        isAssessmentEmpty && isSelectedDoc === 2 ) {
                        <button type="button" class="btn-modern btn-ai" (click)="GenerateQuestion()">
                          <span class="btn-icon">
                            <i class="fa-solid fa-wand-magic-sparkles"></i>
                          </span>
                          <span>
                            <strong>AI-Generate Questions</strong>
                            <small>Generate from your document</small>
                          </span>
                        </button>
                        } @if ( trainLLM && isAssessmentAiEnabled &&
                        isAssessmentEmpty && isSelectedDoc === 2 ) {
                        <span class="action-or"> OR </span>
                        }
                        <!-- Manual -->
                        <button type="button" class="btn-modern btn-manual" (click)="onCreateAssQuestion()">
                          <span class="btn-icon">
                            <i class="fa-solid fa-plus"></i>
                          </span>
                          <span>
                            <strong>Manually Add Question</strong>
                            <small>Create your own question</small>
                          </span>
                        </button>
                      </div>
                    </div>
                    }

                    <!-- Questions -->
                    @if (assQuestion().controls.length > 0) {
                    <div class="questions-wrapper">
                      <div class="questions-header">
                        <div>
                          <h4>Assessment Questions</h4>
                          <p>
                            Configure each question and select the correct
                            answer.
                          </p>
                        </div>
                        <button type="button" class="add-question-btn" (click)="onCreateAssQuestion()">
                          <i class="fa-solid fa-plus"></i>
                          Add Question
                        </button>
                      </div>
                      <ng-container formArrayName="assessment">
                        @for ( assessmentCtrl of assQuestion().controls; track
                        assessmentCtrl; let questIndex = $index) {
                        <div class="question-card" [formGroupName]="questIndex">
                          <!-- Question Card Header -->
                          <div class="question-card-header">
                            <div class="question-number">
                              <span>{{ questIndex + 1 }}</span>
                              <div>
                                <strong>Question {{ questIndex + 1 }}</strong>
                                <small>Assessment question</small>
                              </div>
                            </div>
                            <button type="button" class="delete-question" (click)="removeAssQuestion(questIndex)"
                              title="Remove Question">
                              <i class="pi pi-trash"></i>
                            </button>
                          </div>
                          <!-- Question Type + Marks -->
                          <div class="question-meta">
                            <div class="meta-field question-type-field">
                              <label>
                                Question Type
                                <span class="required">*</span>
                              </label>
                              <div class="question-types">
                                @for (item of questions; track item) {
                                <label class="question-type-option" [class.active]="
                                    assessmentCtrl.get('answer_type')?.value ===
                                    item.value
                                  ">
                                  <input type="radio" [value]="item.value" [id]="item.viewValue + '_' + questIndex"
                                    formControlName="answer_type" (click)="onSelectedType(item, questIndex)" />
                                  <span class="type-radio"></span>
                                  <span>{{ item.viewValue }}</span>
                                </label>
                                }
                              </div>
                            </div>
                            <div class="meta-field mark-field">
                              <label>
                                Mark
                                <span class="required">*</span>
                              </label>
                              <div class="mark-input">
                                <input type="text" class="input" name="mark" id="mark_{{ questIndex }}"
                                  placeholder="Enter mark" formControlName="mark" (keydown)="keyDownHandler($event)"
                                  (keypress)="numericOnlyHandler($event)" />
                                <span>pts</span>
                              </div>
                              @if ( (assessmentCtrl.get('mark')?.touched ||
                              assessmentCtrl.get('mark')?.dirty) &&
                              assessmentCtrl.get('mark')?.invalid ) {
                              <div class="validation-message">
                                @if (
                                assessmentCtrl.get('mark')?.hasError('whitespace')
                                ) {
                                <span> Mark is required </span>
                                }
                              </div>
                              }
                            </div>
                          </div>
                          <!-- Question -->
                          <div class="question-body">
                            <label class="field-label">
                              Question
                              <span class="required">*</span>
                            </label>
                            <div class="question-input-wrapper">
                              <input type="text" name="question" id="question_{{ questIndex }}"
                                class="input question-input" placeholder="Enter your question here..."
                                formControlName="question" (keydown)="keyDownHandler($event)" />
                            </div>
                            @if ( (assessmentCtrl.get('question')?.touched ||
                            assessmentCtrl.get('question')?.dirty) &&
                            assessmentCtrl.get('question')?.invalid ) {
                            <div class="validation-message">
                              @if (
                              assessmentCtrl.get('question')?.hasError('whitespace')
                              ) {
                              <span> Question is required </span>
                              }
                            </div>
                            }
                          </div>
                          <!-- Answers -->
                          @if (isShown[questIndex]) {
                          <div class="answers-section" formArrayName="answer">
                            <div class="answers-header">
                              <div>
                                <label class="field-label">Answer Options</label>
                                <span>
                                  Select the radio button beside the correct
                                  answer.
                                </span>
                              </div>
                              <span class="answer-count">
                                {{
                                assQuestAnswers(questIndex).controls.length
                                }}
                                options
                              </span>
                            </div>
                            @for ( answerCtrl of
                            assQuestAnswers(questIndex).controls; track
                            answerCtrl; let optionIndex = $index) {
                            <div class="answer-row" [formGroupName]="optionIndex">
                              <div class="option-number">
                                {{ optionIndex + 1 }}
                              </div>
                              <div class="answer-input-wrapper">
                                <input type="text" name="answer" class="input"
                                  id="answer_{{ questIndex }}_{{ optionIndex }}" placeholder="Enter answer option..."
                                  formControlName="answer" (keydown)="keyDownHandler($event)" />
                                @if ( (answerCtrl.get('answer')?.touched ||
                                answerCtrl.get('answer')?.dirty) &&
                                answerCtrl.get('answer')?.invalid ) {
                                <div class="validation-message">
                                  @if (
                                  answerCtrl.get('answer')?.hasError('whitespace')
                                  ) {
                                  <span> Answer is required </span>
                                  }
                                </div>
                                }
                              </div>
                              <label class="correct-answer" [class.selected]="
                                  answerCtrl.value.is_correct_answer
                                ">
                                <input type="radio" id="isAnswer_{{ questIndex }}-{{
                                    optionIndex
                                  }}" name="is_correct_answer{{ questIndex }}"
                                  [checked]="answerCtrl.value.is_correct_answer" value="{{ isChecked }}" (click)="
                                    oncheckedOptions(
                                      $event,
                                      assessmentCtrl,
                                      questIndex,
                                      optionIndex
                                    )
                                  " />
                                <span class="correct-radio"></span>
                                <span class="correct-label">
                                  <i class="fa-solid fa-check"></i>
                                  Correct
                                </span>
                              </label>
                              @if ( assQuestAnswers(questIndex).controls.length
                              > 1 ) {
                              <button type="button" class="remove-answer" (click)="
                                  removeAssOptions(questIndex, optionIndex)
                                " title="Remove answer">
                                <i class="pi pi-trash"></i>
                              </button>
                              }
                            </div>
                            }
                            <!-- Correct Answer Validation -->
                            @if (selectedOptions[questIndex]) {
                            <div class="correct-answer-error">
                              <i class="fa-solid fa-circle-exclamation"></i>
                              Please select one correct answer.
                            </div>
                            }
                            <!-- Add Answer -->
                            <button type="button" class="add-answer-btn" (click)="onCreateAssOption(questIndex)">
                              <i class="fa-solid fa-plus"></i>
                              Add answer option
                            </button>
                          </div>
                          }
                        </div>
                        }
                      </ng-container>
                      <!-- Bottom Add Question -->
                      <div class="questions-footer">
                        <button type="button" class="add-question-outline" (click)="onCreateAssQuestion()">
                          <i class="fa-solid fa-plus"></i>
                          Add another question
                        </button>
                      </div>
                    </div>
                    }
                  </div>
                </div>

                <!--survey section-->
                <div id="survey" class="survey-tab content-tab" style="display: none">
                  <div class="survey-container">
                    <!-- Header -->
                    <div class="survey-header">
                      <div>
                        <!-- <div class="survey-eyebrow">
                                                      <i class="fa-solid fa-square-poll-vertical"></i>
                                                      Survey
                                                    </div> -->

                        <h3>Create Survey</h3>

                        <p>
                          Create questions and answer options to collect learner
                          feedback.
                        </p>
                      </div>

                      @if (surveyQuestions().controls.length > 0) {
                      <div class="survey-count">
                        <span>{{ surveyQuestions().controls.length }}</span>
                        <small>
                          Question{{
                          surveyQuestions().controls.length > 1 ? "s" : ""
                          }}
                        </small>
                      </div>
                      }
                    </div>

                    <!-- Empty State -->
                    @if (surveyQuestions().controls.length === 0) {
                    <div class="survey-empty">
                      <div class="survey-empty-icon">
                        <i class="fa-solid fa-square-poll-vertical"></i>
                      </div>
                      <h4>No survey questions yet</h4>
                      <p>
                        Add questions to collect feedback, opinions and
                        responses from your learners.
                      </p>
                      <button type="button" class="survey-primary-btn" (click)="onCreateSurveyQuestion()">
                        <i class="fa-solid fa-plus"></i>
                        Add Survey Question
                      </button>
                    </div>
                    }

                    <!-- Questions -->
                    @if ( domElementControl.showCreateNewSurQuestion &&
                    is_survey_found && surveyQuestions().controls.length > 0 ) {
                    <div class="survey-questions">
                      <!-- Section Header -->
                      <div class="survey-section-header">
                        <div>
                          <h4>Survey Questions</h4>
                          <p>
                            Add questions and configure the available response
                            options.
                          </p>
                        </div>
                        <button type="button" class="survey-add-question-btn" (click)="onCreateSurveyQuestion()">
                          <i class="fa-solid fa-plus"></i>
                          Add Question
                        </button>
                      </div>
                      <ng-container formArrayName="survey">
                        <!-- Question Card -->
                        @for ( surveyCtrl of surveyQuestions().controls; track
                        surveyCtrl; let questIndex = $index) {
                        <div class="survey-question-card" [formGroupName]="questIndex">
                          <!-- Question Header -->
                          <div class="survey-question-header">
                            <div class="survey-question-title">
                              <span class="survey-question-number">
                                {{ questIndex + 1 }}
                              </span>
                              <div>
                                <strong> Question {{ questIndex + 1 }} </strong>
                                <small> Survey question </small>
                              </div>
                            </div>
                            <button type="button" class="survey-delete-btn" title="Remove Question"
                              (click)="onRemoveSurveyQuestion(questIndex)">
                              <i class="pi pi-trash"></i>
                            </button>
                          </div>
                          <!-- Question -->
                          <div class="survey-question-body">
                            <label class="survey-field-label">
                              Question
                              <span class="required">*</span>
                            </label>
                            <div class="survey-question-input">
                              <input type="text" name="question" id="survey_question_{{ questIndex }}" class="input"
                                placeholder="Enter your survey question..." formControlName="question"
                                (keydown)="keyDownHandler($event)" />
                            </div>
                            <!-- Question Validation -->
                            @if ( (surveyCtrl.get('question')?.touched ||
                            surveyCtrl.get('question')?.dirty) &&
                            surveyCtrl.get('question')?.invalid ) {
                            <div class="survey-validation">
                              @if (
                              surveyCtrl.get('question')?.hasError('whitespace')
                              ) {
                              <span> Question is required </span>
                              }
                            </div>
                            }
                            <!-- Answers -->
                            <div class="survey-answers" formArrayName="answer">
                              <div class="survey-answers-header">
                                <div>
                                  <label class="survey-field-label">
                                    Answer Options
                                  </label>
                                  <span>
                                    Add the responses learners can choose from.
                                  </span>
                                </div>
                                <span class="survey-option-count">
                                  {{
                                  surveyOptions(questIndex).controls.length
                                  }}
                                  options
                                </span>
                              </div>
                              <!-- Answer Rows -->
                              @for ( answerCtrl of
                              surveyOptions(questIndex).controls; track
                              answerCtrl; let optionIndex = $index) {
                              <div class="survey-answer-row" [formGroupName]="optionIndex">
                                <span class="survey-option-number">
                                  {{ optionIndex + 1 }}
                                </span>
                                <div class="survey-answer-input">
                                  <input type="text" name="answer" class="input" id="survey_answer_{{ questIndex }}_{{
                                      optionIndex
                                    }}" placeholder="Enter answer option..." formControlName="answer"
                                    (keydown)="keyDownHandler($event)" />
                                  <!-- Answer Validation -->
                                  @if ( (answerCtrl.get('answer')?.touched ||
                                  answerCtrl.get('answer')?.dirty) &&
                                  answerCtrl.get('answer')?.invalid ) {
                                  <div class="survey-validation">
                                    @if (
                                    answerCtrl.get('answer')?.hasError('whitespace')
                                    ) {
                                    <span> Answer is required </span>
                                    }
                                  </div>
                                  }
                                </div>
                                <!-- Remove Answer -->
                                @if ( surveyOptions(questIndex).controls.length
                                > 1 ) {
                                <button type="button" class="survey-remove-answer" title="Remove Answer" (click)="
                                    removeSurveyOptions(questIndex, optionIndex)
                                  ">
                                  <i class="pi pi-trash"></i>
                                </button>
                                }
                              </div>
                              }
                              <!-- Add Option -->
                              <button type="button" class="survey-add-option"
                                (click)="oncreateSurveyOptions(questIndex)">
                                <i class="fa-solid fa-plus"></i>
                                Add answer option
                              </button>
                            </div>
                          </div>
                        </div>
                        }
                      </ng-container>
                      <!-- Footer -->
                      <div class="survey-footer">
                        <button type="button" class="survey-add-question-outline" (click)="onCreateSurveyQuestion()">
                          <i class="fa-solid fa-plus"></i>
                          Add another question
                        </button>
                      </div>
                    </div>
                    }
                  </div>
                </div>

                <!--Poll section-->
                <div id="poll" class="poll-tab content-tab" style="display: none">
                  <div class="poll-container">
                    <!-- Header -->
                    <div class="poll-header">
                      <div>
                        <!-- <div class="poll-eyebrow">
                                                        <i class="fa-solid fa-chart-simple"></i>
                                                        Poll
                                                      </div> -->

                        <h3>Create Poll</h3>

                        <p>
                          Create quick questions and answer choices to collect
                          learner opinions.
                        </p>
                      </div>

                      @if (pollQuestions().controls.length > 0) {
                      <div class="poll-count">
                        <span>{{ pollQuestions().controls.length }}</span>
                        <small>
                          Poll{{
                          pollQuestions().controls.length > 1 ? "s" : ""
                          }}
                        </small>
                      </div>
                      }
                    </div>

                    <!-- Empty State -->
                    @if (pollQuestions().controls.length === 0) {
                    <div class="poll-empty">
                      <div class="poll-empty-icon">
                        <i class="fa-solid fa-chart-simple"></i>
                      </div>
                      <h4>No poll questions yet</h4>
                      <p>
                        Create a quick poll to understand learner opinions,
                        preferences, or feedback.
                      </p>
                      <button type="button" class="poll-primary-btn" (click)="onCreatePollQuestion()">
                        <i class="fa-solid fa-plus"></i>
                        Add Poll Question
                      </button>
                    </div>
                    }

                    <!-- Poll Questions -->
                    @if ( domElementControl.showCreateNewPolQuestion &&
                    is_polls_found && pollQuestions().controls.length > 0 ) {
                    <div class="poll-questions">
                      <!-- Section Header -->
                      <div class="poll-section-header">
                        <div>
                          <h4>Poll Questions</h4>
                          <p>
                            Add a question and provide the choices learners can
                            vote for.
                          </p>
                        </div>
                        <button type="button" class="poll-add-question-btn" (click)="onCreatePollQuestion()">
                          <i class="fa-solid fa-plus"></i>
                          Add Question
                        </button>
                      </div>
                      <ng-container formArrayName="polls">
                        <!-- Poll Card -->
                        @for ( pollCtrl of pollQuestions().controls; track
                        pollCtrl; let questIndex = $index) {
                        <div class="poll-question-card" [formGroupName]="questIndex">
                          <!-- Card Header -->
                          <div class="poll-question-header">
                            <div class="poll-question-title">
                              <span class="poll-question-number">
                                {{ questIndex + 1 }}
                              </span>
                              <div>
                                <strong>
                                  Poll Question {{ questIndex + 1 }}
                                </strong>
                                <small> Learner voting question </small>
                              </div>
                            </div>
                            <button type="button" class="poll-delete-btn" title="Remove Poll"
                              (click)="removePollQuestion(questIndex)">
                              <i class="pi pi-trash"></i>
                            </button>
                          </div>
                          <!-- Question -->
                          <div class="poll-question-body">
                            <label class="poll-field-label">
                              Question
                              <span class="required">*</span>
                            </label>
                            <div class="poll-question-input">
                              <span class="poll-question-prefix"> Q </span>
                              <input type="text" name="question" id="poll_question_{{ questIndex }}" class="input"
                                placeholder="Ask your poll question..." formControlName="question"
                                (keydown)="keyDownHandler($event)" />
                            </div>
                            <!-- Question Validation -->
                            @if ( (pollCtrl.get('question')?.touched ||
                            pollCtrl.get('question')?.dirty) &&
                            pollCtrl.get('question')?.invalid ) {
                            <div class="poll-validation">
                              @if (
                              pollCtrl.get('question')?.hasError('whitespace') )
                              {
                              <span> Question is required </span>
                              }
                            </div>
                            }
                            <!-- Choices -->
                            <div class="poll-choices" formArrayName="answer">
                              <div class="poll-choices-header">
                                <div>
                                  <label class="poll-field-label">
                                    Poll Choices
                                  </label>
                                  <span>
                                    Add the options learners can vote for.
                                  </span>
                                </div>
                                <span class="poll-choice-count">
                                  {{ pollChoices(questIndex).controls.length }}
                                  choices
                                </span>
                              </div>
                              <!-- Choice -->
                              @for ( answerCtrl of
                              pollChoices(questIndex).controls; track
                              answerCtrl; let optionIndex = $index) {
                              <div class="poll-choice-row" [formGroupName]="optionIndex">
                                <!-- Number -->
                                <span class="poll-choice-number">
                                  {{ optionIndex + 1 }}
                                </span>
                                <!-- Choice Input -->
                                <div class="poll-choice-input">
                                  <input type="text" name="answer" class="input" id="poll_answer_{{ questIndex }}_{{
                                      optionIndex
                                    }}" placeholder="Enter poll choice..." formControlName="answer"
                                    (keydown)="keyDownHandler($event)" />
                                  <!-- Validation -->
                                  @if ( (answerCtrl.get('answer')?.touched ||
                                  answerCtrl.get('answer')?.dirty) &&
                                  answerCtrl.get('answer')?.invalid ) {
                                  <div class="poll-validation">
                                    @if (
                                    answerCtrl.get('answer')?.hasError('whitespace')
                                    ) {
                                    <span> Answer is required </span>
                                    }
                                  </div>
                                  }
                                </div>
                                <!-- Delete Choice -->
                                @if ( pollChoices(questIndex).controls.length >
                                1 ) {
                                <button type="button" class="poll-remove-choice" title="Remove Choice" (click)="
                                    removePollChoice(questIndex, optionIndex)
                                  ">
                                  <i class="pi pi-trash"></i>
                                </button>
                                }
                              </div>
                              }
                              <!-- Add Choice -->
                              <button type="button" class="poll-add-choice" (click)="onCreatePollChoice(questIndex)">
                                <i class="fa-solid fa-plus"></i>
                                Add poll choice
                              </button>
                            </div>
                          </div>
                        </div>
                        }
                      </ng-container>
                      <!-- Footer -->
                      <div class="poll-footer">
                        <button type="button" class="poll-add-question-outline" (click)="onCreatePollQuestion()">
                          <i class="fa-solid fa-plus"></i>
                          Add another poll
                        </button>
                      </div>
                    </div>
                    }
                  </div>
                </div>

                <!--notes section-->
                <div id="notes" class="notes-tab content-tab" style="display: none">
                  <div class="notes-container">
                    <!-- Header -->
                    <div class="notes-header">
                      <div class="notes-header-content">
                        <!-- <div class="notes-eyebrow">
                                                          <i class="fa-solid fa-note-sticky"></i>
                                                          Notes
                                                        </div> -->

                        <h3>Document Notes</h3>

                        <p>
                          Create and organize rich notes for learners using
                          formatted text, lists, links, and other content.
                        </p>
                      </div>

                      @if (notesQuestions().controls.length > 0) {
                      <div class="notes-count">
                        <span>{{ notesQuestions().controls.length }}</span>
                        <small>
                          Note{{
                          notesQuestions().controls.length > 1 ? "s" : ""
                          }}
                        </small>
                      </div>
                      }
                    </div>

                    <!-- Empty State -->
                    @if (!domElementControl.showCreateNewNotesQuestion) {
                    <div class="notes-empty">
                      <div class="notes-empty-icon">
                        <i class="fa-solid fa-file-lines"></i>
                      </div>
                      <h4>Create your first note</h4>
                      <p>
                        Add rich learning content, explanations, instructions,
                        or supporting information for your learners.
                      </p>
                      <button type="button" class="notes-primary-btn" (click)="onCreateNotesQuestion()">
                        <i class="fa-solid fa-plus"></i>
                        Add Notes
                      </button>
                    </div>
                    }

                    <!-- Notes Content -->
                    @if ( domElementControl.showCreateNewNotesQuestion &&
                    is_notes_found ) {
                    <div class="notes-content">
                      <!-- Section Header -->
                      <div class="notes-section-header">
                        <div>
                          <h4>Learning Notes</h4>
                          <p>Add or edit the content that learners will see.</p>
                        </div>
                        <button type="button" class="notes-add-btn" (click)="onCreateNotesQuestion()">
                          <i class="fa-solid fa-plus"></i>
                          Add Note
                        </button>
                      </div>
                      <!-- Notes Form -->
                      <ng-container formArrayName="notes">
                        @for ( notesCtrl of notesQuestions().controls; track
                        notesCtrl; let questIndex = $index) {
                        <div class="notes-card" [formGroupName]="questIndex">
                          <!-- Card Header -->
                          <div class="notes-card-header">
                            <div class="notes-card-title">
                              <span class="notes-number">
                                {{ questIndex + 1 }}
                              </span>
                              <div>
                                <strong> Note {{ questIndex + 1 }} </strong>
                                <small> Rich content </small>
                              </div>
                            </div>
                            <button type="button" class="notes-delete-btn" title="Remove Note"
                              (click)="removeNotesQuestion(questIndex)">
                              <i class="pi pi-trash"></i>
                            </button>
                          </div>
                          <!-- Editor -->
                          <div class="notes-editor-wrapper">
                            <div class="notes-editor-label">
                              <div>
                                <label>
                                  Note Content
                                  <span class="required">*</span>
                                </label>
                                <span>
                                  Write and format your learning content
                                </span>
                              </div>
                              <span class="notes-editor-type">
                                <i class="fa-solid fa-pen-to-square"></i>
                                Rich Text
                              </span>
                            </div>
                            <div class="notes-editor">
                              <p-editor id="note_{{ questIndex }}" formControlName="question"
                                [config]="editorNotesConfig" [style]="{ height: '220px' }">
                              </p-editor>
                            </div>
                            <!-- Validation -->
                            @if ( (notesCtrl.get('question')?.touched ||
                            notesCtrl.get('question')?.dirty) &&
                            notesCtrl.get('question')?.invalid ) {
                            <div class="notes-validation">
                              @if (
                              notesCtrl.get('question')?.hasError('whitespace')
                              ) {
                              <span> Note content is required </span>
                              }
                            </div>
                            }
                          </div>
                        </div>
                        }
                      </ng-container>
                      <!-- Footer -->
                      <div class="notes-footer">
                        <button type="button" class="notes-add-outline" (click)="onCreateNotesQuestion()">
                          <i class="fa-solid fa-plus"></i>
                          Add another note
                        </button>
                      </div>
                    </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="card-footer">
          <footer>
            <div class="row is-fullwidth">
              <div class="col-6 is-6 lessonPublish">
                <!-- <div class="field responsiveRadioBtn">
                                                <input
                                                  id="switchPublish"
                                                  type="checkbox"
                                                  name="publish"
                                                  class="switch is-small is-success"
                                                  formControlName="publish"
                                                  [(ngModel)]="isPublish"
                                                  />
                                                  <label for="switchPublish">Publish this lesson?</label>
                                                </div> -->
              </div>
              <div class="col-6 is-6 lessonSubmitBtn has-text-right pull-right"
                [ngClass]="{ disabled: showBtnSpinner }">
                <button type="button" class="button mar-0-5 is-small" (click)="hideFileUploadModal(upLoadedFileList)">
                  Cancel
                </button>
                @if (stepperIndex==0) {
                <button type="button" class="button mar-0-5 is-link is-small disabledBtn" [disabled]="
                    !uploadFileForm.controls['title'].valid ||
                    upLoadedFileList.length == 0
                  " (click)="Continue()">
                  Next
                </button>
                <!-- <a
                                                  class="button is-link is-loading is-small"
                                                  style="min-width: 100px"
                                                  *ngIf="showBtnSpinner"
                                                ></a> -->
                } @else { @if(stepperIndex >= 1){
                <button type="button" class="button mar-0-5 is-link is-small disabledBtn" (click)="SaveLesson()">
                  Save
                </button>
                } @if(stepperIndex >= 2){
                <button type="button" class="button mar-0-5 is-link is-small disabledBtn" (click)="Stepback()">
                  Back
                </button>
                } @if (!trainLLM) {
                <button type="button" class="button mar-0-5 is-link is-small disabledBtn" (click)="newLessonCreate()">
                  {{ stepperIndex == 4 ? "Complete" : "Next" }}
                </button>
                <!-- <a
                                                  class="button is-link is-loading is-small"
                                                  style="min-width: 100px"
                                                  *ngIf="showBtnSpinner"
                                                ></a> -->
                } @if (trainLLM) {
                <button type="button" class="button mar-0-5 is-link is-small disabledBtn" (click)="Continue()">
                  {{ stepperIndex == 4 ? "Complete" : "Next" }}
                </button>
                <!-- <a
                                                class="button is-link is-loading is-small"
                                                style="min-width: 100px"
                                                *ngIf="showBtnSpinner"
                                              ></a> -->
                } }
                <!-- <ng-container *ngIf="activeTab !=='lesson'">
                                          <button
                                            type="button"
                                            class="button is-link is-small disabledBtn"
                                            (click)="createNewFileData()"
                                            [disabled]="uploadFileForm.controls['assessment'].length==0"
                                            *ngIf="!showBtnSpinner">
                                            <i class="fa fa-upload is-small mar-0-5"></i> Upload
                                          </button>
                                          <a
                                            class="button is-link is-loading is-small"
                                            style="min-width: 100px"
                                            *ngIf="showBtnSpinner"
                                          ></a> </ng-container> -->
              </div>
            </div>
          </footer>
        </div>
      </div>
    </div>
  </div>
</div>

<app-excel-editor [file]="upLoadedFileList[0]" [companyId]="companyIdForConversion" [classId]="group_id"
  [modelType]="isSelectedDoc?.model_type" [documentTitle]="uploadFileForm.controls['title'].value" [stateCode]="uploadFileForm.controls['policy_state'].value"
  [chatUserList]="selectedClassList" [isDownload]="uploadFileForm.controls['download_link'].value"
  [messageId]="message_id" [llm_train_id] = excelEditorLLMTrainId [(visible)]="showExcelEditor" (onSave)="onExcelEditorSave($event)"
  (onCancel)="onExcelEditorCancel()"></app-excel-editor>

@if (isTrainingLLM) {
<progress-spinner></progress-spinner>
}
